import e from"react";var t={noOptionsMessageDefault:function(){return e.createElement("span",null,"Не має опцій")},loadingMessageDefault:function(){return e.createElement("span",null,"Завантаження...")}};export{t as default};
//# sourceMappingURL=defaultProps.js.map
